import {ChangeDetectorRef, Component, ElementRef, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractTextInput} from "../abstract-text-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIFilterTextInputComponent),
            multi: true
        }
    ],
    selector: "fui-filter-text-input",
    styleUrls: ["./filter-text-input.component.scss"],
    templateUrl: "./filter-text-input.component.html",
    standalone: false
})
export class FUIFilterTextInputComponent extends FUIAbstractTextInput {
    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }
}
